export default __webpack_public_path__ + "static/neue-haas-grotesk-text-56-roman-italic-15b51e74b508f76801236250b34020bc.woff2";